import { render, staticRenderFns } from "./ChatModeration.vue?vue&type=template&id=2d431274"
import script from "./ChatModeration.vue?vue&type=script&lang=js"
export * from "./ChatModeration.vue?vue&type=script&lang=js"
import style0 from "./ChatModeration.vue?vue&type=style&index=0&id=2d431274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports